import styles from './index.module.less';
import { CommonBackContent } from '../Layouts/CommonBackContent';
import { useTranslation } from 'next-i18next';
import { useConfigProvider } from '@/context/ConfigProvider';
import RegisterContent from '../Home/RegisterContent';
import { commonImgPath } from '@/shared/app-common';

const AboutContent = () => {
  const { t } = useTranslation('common');
  const { isBlogWeb } = useConfigProvider();

  if (isBlogWeb) {
    return <></>;
  }

  return (
    <div className={styles.aboutContent} style={{ minHeight: '100vh' }}>
      <img src={commonImgPath + '/our-story-top-bg.webp'} alt="" className={styles.topImage} />
      <CommonBackContent>
        <div className={styles.content}>
          <h1>{t('Origins and Vision')}</h1>
          <p>
            {t(
              `Dolphin Radar was born from a deep understanding of modern social needs, especially on platforms like Instagram, where everyone wants to quickly and easily grasp the changes in their circles: Who has been engaging the most lately? What are the new trends in my social network? Unfortunately, this information is scattered across countless posts and interactions, making manual tracking time-consuming and exhausting. Dolphin Radar exists to provide a time-saving and efficient way for those in need to quickly and accurately access these key insights.`
            )}
          </p>

          <h2>{t('Mission')}</h2>
          <p>
            {t(
              `Our goal is clear: to help you easily stay updated on the latest happenings in the lives of those you care about and in your social circles. Whether it's personal relationships, professional needs, or market insights, Dolphin Radar offers you quick and precise support. Data isn't just cold, hard numbers; it's the bridge that connects you more genuinely with the world.`
            )}
          </p>

          <h2>{t('Inspiration from Everyday Life')}</h2>
          <p>
            {t(
              `The inspiration for creating this product comes from real stories around us. For instance, a friend of mine was having some relationship issues. His girlfriend had been frequently interacting with another guy on Instagram, and he wanted to know more but didn't want to scroll through endless posts—it was just too much work.`
            )}
          </p>
          <p>
            {t(
              `Then there are the younger fans who can't get enough of their favorite celebrities. They're glued to their phones, constantly checking Instagram to see which brands their idols are collaborating with, if their follower counts are going up, and how their recent appearances are being received. They need to keep up with these changes quickly, without having to do all the manual tracking.`
            )}
          </p>
          <p>
            {t(
              `And let's not forget about parents—like myself—who worry about their kids encountering inappropriate content on Instagram but don't know how to monitor their activities.`
            )}
          </p>

          <h2>{t("Dolphin Radar's Versatile Applications")}</h2>
          <p>
            {t(
              `Beyond personal relationships, Dolphin Radar is also a powerful tool for businesses looking to understand consumer behavior and competitors. With ongoing data collection and AI insights, Dolphin Radar helps brands analyze market trends and optimize their social media marketing strategies, boosting their competitive edge.`
            )}
          </p>

          <h3>{t('Competitor Analysis')}</h3>
          <p>
            {t(
              `Dolphin Radar not only helps users stay in the loop with their social circles but also allows them to observe competitors in the Instagram space. Our Web Viewer enables users to discreetly check competitors' interactions and posts, giving brands a clearer understanding of the market landscape and consumer preferences, leading to smarter decisions. For influencers running Instagram marketing, Dolphin Radar offers tremendous value as well. They can use our tool to analyze the marketing strategies of similar influencers, see which posts resonate more, and learn what content their followers enjoy, optimizing their practices accordingly.`
            )}
          </p>

          <h3>{t('Investigation and Collaboration')}</h3>
          <p>
            {t(
              `We welcome partnerships with investigation agencies to provide our clients with greater information accessibility and efficiency in analysis. Through these collaborations, Dolphin Radar delivers more comprehensive and precise market insights, saving users time and effort in data collection and organization.`
            )}
          </p>

          <h3>{t('Monitoring Brand Activities')}</h3>
          <p>
            {t(
              `For brand activities, Dolphin Radar helps companies track everything from event participation and collaboration effectiveness to consumer feedback. By analyzing data continuously, brands can swiftly adjust their marketing strategies to maximize the impact of their activities.`
            )}
          </p>
          <p>
            {t(
              `Of course, Dolphin Radar isn't limited to the areas mentioned; we are continually exploring and expanding its versatility, aiming to make Dolphin Radar impactful in even more fields.`
            )}
          </p>

          <h2>{t('Unique Technology and Ease of Use')}</h2>
          <p>
            {t(
              `When designing Dolphin Radar, we prioritized simplicity and user-friendliness! With our unique AI technology and powerful data analysis, you can gain insights into social dynamics in just a few steps. We also provide ongoing tracking and analysis of long-term data, so you can see not only the current interactions but also long-term trends and changes in your social landscape.`
            )}
          </p>

          <h2>{t('Safety and Privacy')}</h2>
          <p>
            {t(
              'Most importantly, Dolphin Radar is completely anonymous and secure, ensuring you can legally and safely access the information you need while protecting your privacy and providing accurate insights.'
            )}
          </p>
          <p>
            {t(
              "Dolphin Radar is your intelligent social assistant. Whether you want to strengthen personal relationships or gain insights into market dynamics, we're here to support you. Our product tightens the connections between people, making social interactions simpler and deeper."
            )}
          </p>
          <p>{t('Dolphin Radar—using data to bridge the gap between people, making your social life easier!')}</p>
        </div>
        <RegisterContent />
      </CommonBackContent>
    </div>
  );
};

export default AboutContent;
